export default __webpack_public_path__ + "static/graphics-mobile-65297b776abbc8f1690d9da5bb3b6554.webp";